angular
  .module('goodsAdd')
  .component('goodsAdd', {
    template: require('./goods-add.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'Upload',
      function GoodsAddViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, Upload) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'goods';
        const API_URL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.META = { medias: [''] };
        this.META.durations = Array(101).fill().map((x, i) => i * 5);

        function initialze(ctrl) {
          ctrl.PRODUCTS = ctrl.meta.carTypes.map(carType => ({ GROUP_GOODS_ID: carType.ITEMCD, ITEMCD: carType.ITEMCD, ITEMNM: carType.ITEMNM, DURATION: '0', DURATION_TXT: '' }));
        }

        $resource(`${API_URL}/admin/meta/subscription/add `).get().$promise
          .then((data) => {
            this.meta = data;
            initialze(this);
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.removeProduct = (targetProduct) => {
          this.PRODUCTS = this.PRODUCTS.filter(product => product !== targetProduct);
        };
        this.submit = () => {
          if (!this.META.TYPE || this.META.TYPE.length < 1) {
            alert($translate.instant('상품명을 입력해주세요.'));
            return;
          }
          if (!this.META.DESCRIPTION || this.META.DESCRIPTION.length < 1) {
            alert($translate.instant('상품 설명을 입력해주세요.')); // translate
            return;
          }
          if (!this.META.DESCRIPTION_EN || this.META.DESCRIPTION_EN.length < 1) {
            alert($translate.instant('영문 설명을 입력해주세요.'));
            return;
          }
          if (!this.META.DETAIL_DESCRIPTION || this.META.DETAIL_DESCRIPTION.length < 1) {
            alert($translate.instant('설명을 작성해주세요.'));
            return;
          }
          if (!this.META.DETAIL_DESCRIPTION_EN || this.META.DETAIL_DESCRIPTION_EN.length < 1) {
            alert($translate.instant('상세영문 설명을 입력해주세요.'));
            return;
          }

          if (this.PRODUCTS.filter((product) => {
            if (product.PRICE === null || product.PRICE === undefined) {
              return true;
            }
            if (product.GOODS_PRICE === null || product.GOODS_PRICE === undefined) {
              return true;
            }
            return product.EMPLOYEE_PRICE === null || product.EMPLOYEE_PRICE === undefined;
          }).length > 0) {
            alert($translate.instant('가격을 입력해주세요.'));
            return;
          }
          if (this.PRODUCTS.filter(product => product.DURATION_TXT.length < 1).length > 0) {
            alert($translate.instant('세차 시간 표기를 입력해주세요.'));
            return;
          }

          const goods = this.PRODUCTS.map((product) => {
            product.TYPE = this.META.TYPE;
            product.DESCRIPTION = this.META.DESCRIPTION;
            product.DESCRIPTION_EN = this.META.DESCRIPTION_EN;
            product.DETAIL_DESCRIPTION = this.META.DETAIL_DESCRIPTION;
            product.DETAIL_DESCRIPTION_EN = this.META.DETAIL_DESCRIPTION_EN;
            product.URLS = this.META.medias;
            return product;
          });
          $resource(`${API_URL}/admin/goods`).save({ GOODS: goods }).$promise
            .then(() => {
              $location.path('/service/goods');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.addImage = () => {
          this.META.medias.push('');
        };

        this.uploadImage = (media, files, index) => {
          if (files && files.length) {
            const file = files[0];
            Upload.upload({
              url: `${API_URL}/admin/file/options`,
              file,
            }).progress(() => {
            }).success((data, status, headers, config) => { // eslint-disable-line no-unused-vars
              media = data.url;
              this.META.medias[index] = data.url;
              alert(this.META.medias);
            });
          }
        };

        this.removeImage = function removeImage(url, index) { // eslint-disable-line no-unused-vars
          const URLS = [];
          if (this.META.medias) {
            this.META.medias.forEach((item) => {
              if (item !== url) {
                URLS.push(item);
              }
            });
          }
          this.META.medias = URLS;
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/goods-add/goods-add.component.js